var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[((_vm.userProfile && _vm.userProfile.id))?_c('Nav',{attrs:{"userProfile":(_vm.userProfile && _vm.userProfile.id)}}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }